import { PropsWithChildren } from 'react'
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router'
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'

type RouterLinkProps = PropsWithChildren<MuiLinkProps & ReactRouterLinkProps>

/**
 * RouterLink component that wraps React Router's Link with MUI's Link.
 *
 * This allows for using MUI's styling and theming capabilities while maintaining the functionality of React Router's Link.
 *
 * Any other imports of react-router's Link should be passed into MUI `component` props.
 */
export const RouterLink = ({ children, to, ...props }: RouterLinkProps) => {
  return (
    <MuiLink component={ReactRouterLink} to={to} {...props}>
      {children}
    </MuiLink>
  )
}
RouterLink.displayName = 'RouterLink'
